import { render, staticRenderFns } from "./HeaderScreen.vue?vue&type=template&id=3ed07be0&scoped=true"
import script from "./HeaderScreen.vue?vue&type=script&lang=js"
export * from "./HeaderScreen.vue?vue&type=script&lang=js"
import style0 from "./HeaderScreen.vue?vue&type=style&index=0&id=3ed07be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed07be0",
  null
  
)

export default component.exports